<script>
import PersonTypeLabel from "@views/admin/treasury/dispersions/components/person-type-label.vue";
import DispersionTable from "@components/treasury/DispersionTable.vue";
import TreasuryDispersionTables from "@components/treasury/TreasuryDispersionTables.vue";
import DispersionTotalCard from "@views/admin/treasury/dispersions/components/dispersion-total-card.vue";
import {mapState} from "vuex";

export default {
  name: "index",
  components: {DispersionTotalCard, TreasuryDispersionTables, DispersionTable, PersonTypeLabel},
  computed: {
    ...mapState("dispersion", ["processors"]),
  },
  data: () => ({
    supplierDispersions: [],
    applicantDispersions: [],
    investorDispersions: [],
    financialAdvisorDispersions: [],
    rgDispersions: [],
    stpBalanceAvailable: 0
  }),
  mounted() {
    axios.get(`/api/financials/stp/balance`)
        .then((res) => this.stpBalanceAvailable = res.data.respuesta.saldo);

    axios.get("/api/dispersion/supplier").then((res) => this.supplierDispersions = res.data );
    axios.get("/api/dispersion/applicant").then((res) => this.applicantDispersions = res.data);
    axios.get("/api/dispersion/investor").then((res) => this.investorDispersions = res.data);
    axios.get("/api/dispersion/financial-advisor").then((res) => this.financialAdvisorDispersions = res.data);
    axios.get("/api/dispersion/rg").then((res) => this.rgDispersions = res.data);
  },
}
</script>

<template>
  <div class="container mt-5">
    <div class="grid grid-cols-4">
      <dispersion-total-card
          class="ml-5"
          icon="DollarSignIcon"
          icon-right
          statistic="STP"
          color="primary"
          :hide-chart="true"
          :amount-available="stpBalanceAvailable"
          :amount-required="processors.stp.required">
      </dispersion-total-card>
    </div>

    <treasury-dispersion-tables
        identity="supplier"
        :expand="true"
        :disperse-action="'/api/dispersion/supplier/disperse'"
        :refund-action="'/api/dispersion/supplier/refund'"
        :show-project-info="true"
        color="success"
        title="Proveedores"
        :dispersions="supplierDispersions" />

    <treasury-dispersion-tables
        identity="applicant"
        :expand="true"
        :disperse-action="'/api/dispersion/applicant/disperse'"
        :refund-action="'/api/dispersion/applicant/refund'"
        :show-fiscal-info="true"
        color="#ad289f"
        title="Solicitantes"
        :dispersions="applicantDispersions" />

    <treasury-dispersion-tables
        identity="investor"
        :expand="true"
        :disperse-action="'/api/dispersion/investor/disperse'"
        :refund-action="'/api/dispersion/investor/refund'"
        :support-refunds="true"
        :show-fiscal-info="true"
        color="danger"
        title="Inversionistas"
        :dispersions="investorDispersions" />

    <treasury-dispersion-tables
        identity="financialAdvisor"
        :expand="true"
        :disperse-action="'/api/dispersion/financial-advisor/disperse'"
        :refund-action="'/api/dispersion/financial-advisor/refund'"
        :support-refunds="true"
        :show-fiscal-info="true"
        color="danger"
        title="Asesores financieros"
        :dispersions="financialAdvisorDispersions" />

    <treasury-dispersion-tables
        :expand="true"
        identity="rg"
        :disperse-action="'/api/dispersion/rg/disperse'"
        :refund-action="'/api/dispersion/rg/refund'"
        :show-project-info="true"
        color="success"
        title="RedGirasol"
        :dispersions="rgDispersions" />
  </div>
</template>

<style scoped>

</style>